import { Transforms } from 'slate';

const withFormulas = editor => {
	// Toggle formula's field
	editor.toggleFormula = () => {
		// Do not add formula field if selection is undefined
		if (!editor.selection) return;

		// Remove formula's field if it's active
		if (editor.isElementActive('formula')) return Transforms.removeNodes(editor, {
			match: node => node.type === 'formula'
		});
		
		// Insert formula's field'
		Transforms.insertNodes(editor, [
			{
				type: 'formula',
				formula: '',
				focus: true,
				children: [{ text: '' }]
			}
		]);
	};

	return editor;
};

export default withFormulas;